export function buildScriptureSEO({ book, chapter, verseStart, verseEnd }) {

    const formatBookName = (value) =>
        value
            .replace(/-/g, " ")
            .split(" ")
            .map(p => p.charAt(0).toUpperCase() + p.slice(1))
            .join(" ");

    const bookName = formatBookName(book);

    let reference;

    // ✅ HANDLE BOOK PAGE
    if (!chapter) {
        reference = bookName;
    }
    // ✅ CHAPTER PAGE
    else if (!verseStart) {
        reference = `${bookName} ${chapter}`;
    }
    // ✅ SINGLE VERSE
    else if (!verseEnd || verseStart === verseEnd) {
        reference = `${bookName} ${chapter}:${verseStart}`;
    }
    // ✅ RANGE
    else {
        reference = `${bookName} ${chapter}:${verseStart}–${verseEnd}`;
    }

    const canonical =
        `/songs/${book}` +
        (chapter ? `/${chapter}` : "") +
        (verseStart ? `/${verseStart}${verseEnd ? `-${verseEnd}` : ""}` : "");

    return {
        title: `Worship Songs and Hymns for ${reference}`,
        description: `Discover worship songs and hymns connected with ${reference}. Find songs to build a scripture-rooted worship service.`,
        canonical,
        heading: `Worship Songs and Hymns for ${reference}`
    };
}
